import { CommonDeskHeaderProvider } from "@yoon0cean/common/dist/components/CommonDeskHeaderProvider";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { popupFlagState } from "../atoms/popupAtoms/popupFlag";
import { userState } from "../atoms/systemAtoms/user";
import RecoilUsedHeader from "@yoon0cean/common/dist/components/RecoilUsedHeader/RecoilUsedHeader";
import { innerState, recentRefreshState } from "../atoms/systemAtoms/inner";

const HeaderContainer = () => {
  const user = useRecoilValue(userState);
  const recentRefresh = useRecoilValue(recentRefreshState);
  const setInner = useSetRecoilState(innerState);
  const setPopup = useSetRecoilState(popupFlagState);

  return (
    <CommonDeskHeaderProvider recentRefresh={recentRefresh} setInner={setInner}>
      <RecoilUsedHeader
        full_width="100%"
        input_width="720px"
        user={user}
        setPopup={setPopup}
      />
    </CommonDeskHeaderProvider>
  );
};

export default HeaderContainer;
